@if (active) {
  <button
    (click)="clickOnUrl(tagName, active, type)"
    [title]="active"
    class="btn p-0 border-0">
    <span [ngClass]="getBadgeClass()">{{ type }}</span>
  </button>
} @else {
  @if (inactiveCount) {
    <button
      (click)="clickOnUrl(tagName, inactive ? inactive : active, type, true)"
      [title]="inactive"
      class="btn p-0 border-0">
      <span class="badge badge-light border">{{ type }}</span>
    </button>
    <span class="text-dark"> ({{ inactiveCount }}) </span>
  }
}

